<template>
  <div>
    <vx-card>
      <div class="flex flex-wrap-reverse items-center">
        <div @click="toggleAttachDialog" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
          <feather-icon
            icon="PlusIcon"
            svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Adicionar</span>
        </div>
      </div>
      <vs-table ref="table" :max-items="1000" :noDataText="'Nenhum arquivo anexado'" :data="attachments">
        <template slot="thead">
          <vs-th>N°</vs-th>
          <vs-th>Arquivo</vs-th>
          <vs-th>Anexado Por</vs-th>
          <vs-th>Data de Pagamento</vs-th>
          <vs-th>Ações</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="attachments" :key="indextr" v-for="(attachment, indextr) in data">
              <vs-td>
                <p class="font-medium">{{ indextr + 1 }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ attachment.nome }}</p>
              </vs-td>
              <vs-td>
                <div class="font-medium">
                  <p v-show="attachment.fk_idUsuario != $store.state.user.idUser">{{ attachment.fantasia || attachment.criadoPor}}</p>
                  <p v-show="attachment.fk_idUsuario == $store.state.user.idUser">Você</p>
                </div>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ helpers.dateHelper.formatDateToPTBR(attachment.dataPagamento) }}</p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <vx-prompt
                  title="Pré-visualização"
                  accept-text="Baixar"
                  cancel-text="Abrir"
                  @accept="downloadAttach(attachment.nome, attachment.file, attachment.type)"
                  @cancel="openAttach(attachment.file, attachment.type)"
                  :ref="'vxPrompt-' + indextr">
                  <span>{{attachment.nome}}</span>
                  <br>
                  <div v-if="attachment.type == 'application/pdf'">
                    <span v-show="pageCount == 1">{{pageCount}} página</span>
                    <span v-show="pageCount > 1">{{pageCount}} páginas</span>
                    <pdfViewer @num-pages="pageCount = $event" :src="attachment.file"></pdfViewer>
                  </div>
                  <div v-else-if="attachment.type.match(/image\/.*/)">
                    <img class="w-full" :src="attachment.file" />
                  </div>
                </vx-prompt>
                <feather-icon
                  icon="EyeIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click="$refs['vxPrompt-' + indextr][0].togglePrompt(true)" />
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click="detachFile(indextr)" />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <div class="flex flex-wrap items-center" slot="footer">
        <vs-button class="mr-6" @click="submitData()">Salvar</vs-button>
      </div>
      <vs-prompt
        :active.sync="showAttachDialog"
        @accept="addAttachmentToTable"
        accept-text="Adicionar"
        cancel-text="Cancelar"
        title="Adicionar Anexo">
        <div>
          <span>Data de pagamento</span>
          <datepicker v-model="currentAttachment.date" :format="datepickerFormat" :language="datepickerLanguage"></datepicker>
          <br>
          <input
            type="file"
            class="hidden"
            ref="attachmentInput"
            @change="attachFile($event)"
            accept="image/*,application/pdf"
            name="file" />
          <vs-button
            class="w-full"
            @click="$refs['attachmentInput'].click()">
            {{ currentAttachment.name || 'Selecione um arquivo' }}
          </vs-button>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import helpers from '@/helpers'
import axios from "axios"
import { baseApiUrl } from "@/global"

import Datepicker from 'vuejs-datepicker';
import { ptBR } from 'vuejs-datepicker/src/locale';
import pdfViewer from 'vue-pdf'


export default {
  data() {
    return {
      currentAttachment: {},
      idPurchaseOrder: undefined,
      attachments: [],
      helpers: null,
      showAttachDialog: false,
      pageCount: 0,
      datepickerLanguage: ptBR,
      datepickerFormat: 'dd MMMM yyyy',
    }
  },
  components: {
    Datepicker,
    pdfViewer
  },
  methods: {
    initValues() {
      this.currentAttachment = { date: new Date(), name: '' }
    },
    async loadAttachments() {
      try {
        this.$vs.loading();
        const response = await axios.get(`${baseApiUrl}/purchaseOrders/${this.idPurchaseOrder}/attachments`);
        this.attachments = response.data

      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    toggleAttachDialog() {
      this.showAttachDialog = true
    },
    async attachFile(event) {
      const attachment = event.target.files
      if (!attachment.length) return

      this.currentAttachment.file = await this.helpers.toBase64(attachment[0])
      this.currentAttachment.name = attachment[0].name
      this.currentAttachment.type = attachment[0].type
    },
    addAttachmentToTable() {
      if (!this.currentAttachment) {
        this.$vs.notify({
          title: 'Erro',
          text: 'Nenhum arquivo selecionado',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }

      this.attachments.push({
        nome: this.currentAttachment.name,
        dataPagamento: this.currentAttachment.date,
        fk_idUsuario: this.$store.state.user.idUser,
        file: this.currentAttachment.file,
        type: this.currentAttachment.type
      })
      this.initValues()
    },
    detachFile(index) {
      this.attachments.splice(index, 1)
    },
    async openAttach(base64, type) {
      console.log(type);
      const response = await axios.get(base64, {
        responseType: 'blob'
      })
      const blobUrl = URL.createObjectURL(response.data, { type })

      window.open(blobUrl, '_blank');
    },
    async downloadAttach(name, base64, type) {
      const response = await axios.get(base64, {
        responseType: 'blob'
      })
      const blobUrl = URL.createObjectURL(response.data, { type })
      const fileElement = document.createElement('a');
      fileElement.href = blobUrl;
      fileElement.download = name;

      fileElement.click();
    },
    async submitData() {
      try {
        this.$vs.loading()
        await axios.put(`${baseApiUrl}/purchaseOrders/${this.idPurchaseOrder}/attachments`, { attachments: this.attachments })
        this.$router.push({ name: 'purchaseOrder-list' })

      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel anexar os arquivos",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  async created() {
    this.idPurchaseOrder = this.$route.params.idPurchaseOrder
    this.helpers = helpers
    await this.loadAttachments()
    this.initValues()
  },
}

</script>
